export enum OfferKind {
  SupplierOffer = 1,
  ReceivingOffer = 2,
  OfferRequest = 3
}

(OfferKind as any).__typeName = 'OfferKind';
